import { NUM_MAXIMO_INVERSORES } from "../constants"
import { ListagemItem } from "../types"

export const checarNumeroMaximoDeInversores = (listaInversores: ListagemItem[], id?: number) => {
  if (id){
    return (listaInversores.find(item => item.componente_id === id)?.quantidade || 0) > NUM_MAXIMO_INVERSORES
  }

  return listaInversores.some(item => item.quantidade > NUM_MAXIMO_INVERSORES)
}